module.exports = __webpack_public_path__ + "img/icon_photo_outlined_w.dff77c98.svg";